import React, { FunctionComponent, useState, useEffect } from 'react'; 
import { Row, Col, Card } from 'react-bootstrap';
import { parseToCoin, firstMonthPrice } from '../../services/AmountService';

type ProductResumeProps = {
    title: string,
    priceMonthly: number,
    priceYear: number,
    prorated: boolean,
    annualPayment: boolean
    letMonths: number
}

const CustomProductResumeCard:FunctionComponent<ProductResumeProps> = (props: ProductResumeProps) => {

  const { title, priceMonthly, priceYear, prorated, annualPayment, letMonths } = props;
  const [ proratedPrice, setProratedPrice ] = useState(0);

  useEffect(() => {
    if (prorated) {
      const p = annualPayment ? (firstMonthPrice(priceYear) + (priceYear * letMonths)) : firstMonthPrice(priceMonthly);
      setProratedPrice(p);
    } 
  }, [annualPayment])

  return(
    <Card className="product-resume-card mb-3">
      <Card.Body className="p-3">
        <Card.Title>
          <Row>
            <Col md="6"><span className="title-product">{title}</span></Col>
            <Col md="6" className="text-right">
              {annualPayment ?
              <span><span className="product-price">{parseToCoin(priceYear*10)}</span>{annualPayment ? '/year' : '/month'}</span>
              : <span><span className="product-price">{parseToCoin(priceMonthly)}</span>{annualPayment ? '/year' : '/month'}</span>
              }
            </Col>
          </Row>
        </Card.Title>
        <div className="border-top my-2"></div>
        {annualPayment ?
        <Card.Text className="text-right">
          You'll pay this amount plus fees on the first day of the year.
         You'll pay a prorated price of <span className="product-price">{parseToCoin(annualPayment ? (firstMonthPrice(priceYear) + (priceYear * letMonths)) : firstMonthPrice(priceMonthly))}</span > today.
        </Card.Text>
        : <Card.Text className="text-right">
        You'll pay this amount plus fees on the first day of the month.
         You'll pay a prorated price of <span className="product-price">{parseToCoin(annualPayment ? (firstMonthPrice(priceYear) + (priceYear * letMonths)) : firstMonthPrice(priceMonthly))}</span > today.
      </Card.Text>
      }
      </Card.Body>
    </Card>
  );
}

export default CustomProductResumeCard;